export const TIPO_CONTACTO_EMAIL     = [525, 527, 528, 3284];
export const TIPO_CONTACTO_TELEFONO  = [520, 523, 524];
export const TIPO_CONTACTO_SITIO_WEB = [522, 3283];
export const TIPO_CONTACTO_EMAIL_PORTAL = 525; //el portal da de alta a la persona con un email de este tipo
